import { DateRange, Option, SplitBy } from "@intentsify/types";
import { atom } from "jotai";
import { atomWithReset, useResetAtom } from "jotai/utils";
import { ViewEnum } from "screens/IntentAnalysis/screens/CampaignsTrendingDomains/CampaignsTrendingDomains.types";
import { TopTrendingDomainsOptions } from "./TopTrendingAccounts.types";

export const topTrendingDomainsDateRangeAtom = atomWithReset<DateRange>(
  DateRange.LastFourWeeks
);

export const topTrendingDomainsSplitByAtom = atomWithReset<SplitBy>(
  SplitBy.OneWeek
);

export const topTrendingDomainsViewAtom = atomWithReset<ViewEnum>(
  ViewEnum.TimeSeries
);

export const topTrendingSelectedDomainsAtom = atomWithReset<{
  campaignId: number | undefined;
  data: Array<Option<number>>;
}>({
  campaignId: undefined,
  data: [],
});

export const trendingDomainsOptionsStateAtom =
  atomWithReset<TopTrendingDomainsOptions>({
    isLoading: true,
    topTrendingDomains: [],
  });

export const topTrendingDomainsStateSelector = atom((get) => {
  const { isLoading, topTrendingDomains } = get(
    trendingDomainsOptionsStateAtom
  );
  const selectedDateRange = get(topTrendingDomainsDateRangeAtom);
  const selectedSplitBy = get(topTrendingDomainsSplitByAtom);
  const selectedView = get(topTrendingDomainsViewAtom);
  const selectedDomains = get(topTrendingSelectedDomainsAtom);

  return {
    isLoading,
    topTrendingDomainsOptions: topTrendingDomains,
    selectedDateRange,
    selectedSplitBy,
    selectedView,
    selectedDomains,
  };
});

export const useResetTopTrendingState = () => {
  const resetOptions = useResetAtom(trendingDomainsOptionsStateAtom);
  const resetDateRange = useResetAtom(topTrendingDomainsDateRangeAtom);
  const resetSplitBy = useResetAtom(topTrendingDomainsSplitByAtom);
  const resetView = useResetAtom(topTrendingDomainsViewAtom);
  const resetDomains = useResetAtom(topTrendingSelectedDomainsAtom);

  return () => {
    resetOptions();
    resetDateRange();
    resetSplitBy();
    resetView();
    resetDomains();
  };
};
